import { Client, IFilterClient } from "./types/client";

export enum ClientStatus {
    INACTIVE = 0,
    ACTIVE = 1,
}

export enum ClientTypes {
    Condominio = 0,
    Empresa = 1,
    Escritorio = 2,
    Residencia = 3,
    Publico = 4,
    Outros = 5
}

export enum Regions {
    NORTE = 0,
    SUL = 1,
    LESTE = 2,
    NORDESTE = 3,
    OESTE = 4,
    NOROESTE = 5,
    CENTRO_SUL = 6,
    BARREIRO = 7,
    PAMPULHA = 8,
    VENDA_NOVA = 9,
    CENTRO = 10,
    LESTE_NORDESTE = 11,
}

export enum TypesServices {
    PAID = 0,
    BONUS = 1
}

export enum Recurrent {
    SIM = 0,
    NAO = 1
}

export enum FormMode {
    Add = "add",
    Edit = "edit",
    View = "view",
}

export const defaultClient: Client = {
    id: '',
    type: 0,
    addressCep: '',
    addressCity: '',
    addressNeighborhood: '',
    addressState: '',
    address: '',
    addressNumber: '',
    email: '',
    phone: null,
    startedAsClient: new Date(),
    apartamentsCount: null,
    numberFloors: null,
    numberBlocks: null,
    totalExecutationTime: '00:00:00',
    contractedHours: null,
    alocatedHours: null,
    pendingAlocatedHours: null,
    createdBy: '',
    updatedAt: null,
    updatedBy: null,
    region: null,
    status: 1,
    hasTrash: false,
    trashDays: [],
    trashTimeRange: 0,
    trashStartTime: null,
    trashEndTime: null,
    name: '',
    latitude:null,
    longitude:null,
    createdAt: null,
    hasOwnStock: false,
    cleanKitSize: null,
  }

  export const defaultFilterClient : IFilterClient = {
    name: '',
    email: '',
    phone: '',
    doc: '',
    addressCity: '',
    addressState: '',
    addressCep: '',
    addressNeighborhood: '',
    apartamentsCount: null,
    has_own_stock: null,
    region: null,
    type: null,
    status: null,
  }
